import React from 'react';
import PropTypes from 'prop-types';

function TextField({label, text, textClass='color-black', bgClass='bg-[#F8F9FB]'}) {
  return (
    <div className="w-full px-4 py-2">
      <div
        className={`relative text-left rounded-md  bg-opacity-80 h-[71px] ${bgClass} cursor-pointer`}
      >
        <div className="px-3 py-3 border-b rounded-md">
          <label className={`relative font-bold pl-4 mb-2 ${textClass}`} >
            {label}
          </label>
          <div className={`relative w-full flex items-center justify-between pl-4 text-sm font-normal
            bg-transparent focus:outline-none rounded-md ${textClass}`} >
            {text}
          </div>
        </div>
      </div>
    </div>
  );
}

TextField.propTypes = {
  label: PropTypes.string,
  text: PropTypes.string,
  textClass: PropTypes.string,
  bgClass: PropTypes.string
};

export default TextField;
